import React, { useState, useEffect, Fragment } from 'react'
import './Parametrage.css';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { handleMenuSelection, handleSubMenuSelection } from '../../utils/utils';
import Sidebar from '../../appShell/Sidebar/Sidebar';
import Navbar from '../../appShell/Navbar/Navbar';
import Select, { StylesConfig } from 'react-select';
import { FiEye } from "react-icons/fi"
import { AiFillEyeInvisible } from "react-icons/ai";
import Loader from '../../components/Loader/Loader';
import ProcessSpinner from '../../components/ProcessSpinner/ProcessSpinner';
import { addAgent, getAgent, getAgents, getAppsConfig, getInstitutionsCategoriesCreated, getInstitutionsOfCategory, getRoles, updateAgent, updateAppsConfig } from '../../services/http';


const Parametrage = (props) => {

    const { operationType } = props;

    const navigate = useNavigate();


    const [agent, setAgent] = useState({ nom: "", poste: "", prenom: "", sexe: { label: "", value: "" }, telephone: "", email: "", categorieInstitution: { label: "", value: "" }, institution: { label: "", value: "" }, password: "", type: { label: "", value: "" }, roles: [], isBCC: { label: "", value: "" } });

    const [config, setConfig] = useState({ portal: { name: "", image: null, favicon: null }, web: { name: "", image: null, favicon: null }, general: { color: { primary: null, secondary: null, tertiary: null } } })
    const [displayLoader, setDisplayLoader] = useState(false);
    const [processOngoing, setProcessOngoing] = useState(false)


    // To populate the breadcrumb and update the sidebar menu
    useEffect(() => {
        dispatch({
            type: "SET",
            key: "breadcrumbContent",
            payload: {
                firstLevelText: "Paramètres", firstLevelLink: "", secondLevelText: "Configuration", secondLevelLink: "/configuration", thirdLevelText: "", thirdLevelLink: ""
            }
        });
        handleMenuSelection("settings", dispatch, states);
        handleSubMenuSelection("configuration", dispatch)
    }, [])




    const loadConfigData = async () => {
        const resp = await getAppsConfig()
        if (resp.response && resp.response.status !== 200) {
            console.log("data error ", resp.response)
        } else {
            console.log("data data ", resp.data)
            let webData = resp.data?.applicationInterface;
            let portalData = resp.data?.portail;
            console.log("Data of Config  ", webData, portalData)

            setConfig({
                ...config, general:
                {
                    ...config.general, color:
                    {
                        ...config.general.color, primary: portalData.primary,
                                  secondary: portalData.secondary,
                                  tertiary: portalData.tertiary
                    }
                },
                web: {
                    ...config.web, name: webData.application_name,
                            image: {
                                ...config.web.image, name: webData.background_image_name,
                                          url: webData.background_image
                            },
                            favicon: {
                                ...config.web.favicon, name: webData.application_favicon_name,
                                            url: webData.application_favicon
                            }
                },
                portal: {
                    ...config.portal, name: portalData.portail_application_name,
                               image: {
                                ...config.portal.image, name: portalData.image_name,
                                          url: portalData.image
                               },
                               favicon: {
                                ...config.portal.favicon, name: portalData.portail_favicon_name,
                                            url: portalData.portail_favicon
                               }

                }
            });

            setDisplayLoader(false)
        }


    }



    const [showErrorPortalName, setShowErrorPortalName] = useState(false)
    const [showErrorPortalImage, setShowErrorPortalImage] = useState(false)
    const [showErrorPortalFavicon, setShowErrorPortalFavicon] = useState(false)
    const [showErrorWebName, setShowErrorWebName] = useState(false)
    const [showErrorWebImage, setShowErrorWebImage] = useState(false)
    const [showErrorWebFavicon, setShowErrorWebFavicon] = useState(false)
    const [showErrorColorPrimary, setShowErrorColorPrimary] = useState(false)
    const [showErrorColorSecondary, setShowErrorColorSecondary] = useState(false)
    const [showErrorColorTertiary, setShowErrorColorTertiary] = useState(false)

    const [portalNameErrorMessage, setPortalNameErrorMessage] = useState("")
    const [portalImageErrorMessage, setPortalImageErrorMessage] = useState("")
    const [portalFaviconErrorMessage, setPortalFaviconErrorMessage] = useState("")
    const [webNameErrorMessage, setWebNameErrorMessage] = useState("")
    const [webImageErrorMessage, setWebImageErrorMessage] = useState("")
    const [webFaviconErrorMessage, setWebFaviconErrorMessage] = useState("")
    const [colorPrimaryErrorMessage, setColorPrimaryErrorMessage] = useState("")
    const [colorSecondaryErrorMessage, setColorSecondaryErrorMessage] = useState("")
    const [colorTertiaryErrorMessage, setColorTertiaryErrorMessage] = useState("")

    const dispatch = useDispatch();

    const states = useSelector((state) => state, shallowEqual);

    const handleChangeEntry = (key, e) => {
        var value = e?.currentTarget?.value;
        console.log("e ==> ", e)
        console.log("e value ==> ", value)
        if (key == "portal-name") {
            setConfig({ ...config, portal: { ...config.portal, name: value } });
        }
        if (key == "portal-image") {
            const file = e.currentTarget.files[0];
            setConfig({ ...config, portal: { ...config.portal, image: file } });
        }
        if (key == "portal-favicon") {
            const file = e.currentTarget.files[0]
            setConfig({ ...config, portal: { ...config.portal, favicon: file } });
        }
        if (key == "web-name") {
            setConfig({ ...config, web: { ...config.web, name: value } });
        }
        if (key == "web-image") {
            const file = e.currentTarget.files[0]
            setConfig({ ...config, web: { ...config.web, image: file } });
        }
        if (key == "web-favicon") {
            const file = e.currentTarget.files[0]
            setConfig({ ...config, web: { ...config.web, favicon: file } });
        }

        if (key == "color-primary") {
            setConfig({ ...config, general: { ...config.general, color: { ...config.general.color, primary: value } } });
        }
        if (key == "color-secondary") {
            setConfig({ ...config, general: { ...config.general, color: { ...config.general.color, secondary: value } } });
        }
        if (key == "color-tertiary") {
            setConfig({ ...config, general: { ...config.general, color: { ...config.general.color, tertiary: value } } });
        }

    }

    const handleUpdateConfig = async () => {
        setProcessOngoing(true)
        console.log("Test fav", config.web)
        console.log("config ===<> ", config)
        console.log("web image ===<> ", config.web.image.url)
        console.log("portal image ===<> ", config.portal.image.url)
        if(config.portal?.image?.url !== undefined){
            setConfig({ ...config, portal: { ...config.portal, image: null } });
        }
        if(config.portal?.favicon.url !== undefined){
            setConfig({ ...config, portal: { ...config.portal, favicon: null } });
        }
        if(config.web?.image?.url !== undefined){
            setConfig({ ...config, web: { ...config.web, image: null } });
        }
        if(config.web?.favicon?.url !== undefined){
            setConfig({ ...config, web: { ...config.web, favicon: null } });
        }
        const reqdata = await updateAppsConfig(states.userToken.access_token, config);
        if (reqdata.response && reqdata.response.status !== 200) {
            setProcessOngoing(false)
            toast.error(reqdata.response?.data?.message, {
                position: toast.POSITION.TOP_RIGHT
            });   
        } else {
            setProcessOngoing(false)
            toast.success(`Modification sauvegardée avec succès`, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }



    const handleBack = () => {
        navigate("/")
    }


    useEffect(() => {
        if (config.portal.name != "") {
            setShowErrorPortalName(false)
        }
        if (config.portal.image != "") {
            setShowErrorPortalImage(false)
        }
        if (config.portal.favicon != "") {
            setShowErrorPortalFavicon(false)
        }
        if (config.web.name != "") {
            setShowErrorWebName(false)
        }
        if (config.web.image != "") {
            setShowErrorWebImage(false)
        }
        if (config.web.favicon != "") {
            setShowErrorWebFavicon(false)
        }
        if (config.general.color.primary != "") {
            setShowErrorColorPrimary(false)
        }
        if (config.general.color.secondary != "") {
            setShowErrorColorSecondary(false)
        }
        if (config.general.color.tertiary != "") {
            setShowErrorColorTertiary(false)
        }


    }, [config])



    useEffect(() => {
        loadConfigData();

    }, [])



    return (
        <div>
            <Navbar />
            <div className="main-container" id="container">
                <Sidebar />

                <div id="content" className="main-content">
                    {displayLoader == false ?
                        <div className="layout-px-spacing">

                            <div className="row layout-top-spacing">
                                <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                                </div>
                            </div>
                            <div className="w-90">
                                <h4 className="modal-title text-left " id="exampleModalLabel">{"Paramétrage"}</h4>
                            </div>
                            <div className="widget widget-content widget-content-area mt-3 pt-3">
                                <div className="pl-3 mx-auto">
                                    <h5 className="modal-title py-2 mb-1 text-left " id="exampleModalLabel">{"Portail Web"}</h5>
                                </div>
                                <hr />
                                <div className="w-90 mx-auto">
                                    <div className="d-flex">
                                        <div className="col-sm-4 col-xs-12 px-0">
                                            <div class="form-group row mb-4">
                                                <label for="libelle" class="col-sm-4 col-form-label col-form-label-sm text-dark ">Nom</label>
                                                <div class="col-sm-8">
                                                    <input type="text" onChange={(e) => handleChangeEntry("portal-name", e)}
                                                        className={showErrorPortalName == true ? "form-control custom-form-control form-control-sm new-agent-error-input  mx-auto" : "custom-form-control form-control form-control-sm mx-auto"}
                                                        id="colFormLabelSm" placeholder="" value={config.portal.name} />
                                                    {showErrorPortalName === true && <span className="new-agent-error-span">{portalNameErrorMessage}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 col-xs-12 px-0">
                                            <div class="form-group row  mb-4">
                                                <label for="libelle" class="col-sm-4 col-form-label col-form-label-sm text-dark ">Image</label>
                                                {/* <div class="col-sm-8">
                                                    <input type="file" onChange={(e) => handleChangeEntry("portal-image", e)} 
                                                    className={showErrorPortalImage == true ? "form-control form-control-sm new-agent-error-input custom-form-control  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} 
                                                    id="colFormLabelSm" placeholder="" value={config.portal.image} />
                                                </div> */}
                                                <div className="col-sm-8">
                                                    <div className="custom-file c-file-input">
                                                        <input type="file" onChange={(e) => handleChangeEntry("portal-image", e)} className="custom-form-control custom-file-input" id="customFile" />
                                                        <label class="custom-file-label c-file-label custom-form-control" for="customFile">
                                                            {(config.portal.image?.name != null) ? config.portal.image.name : ""}
                                                        </label>
                                                    </div>
                                                    {showErrorPortalImage === true && <span className="new-agent-error-span">{portalImageErrorMessage}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 col-xs-12 px-1">
                                            <div class="form-group row  mb-4">
                                                <label for="libelle" class="col-sm-4 col-form-label col-form-label-sm text-dark ">Favicon</label>
                                                <div class="col-sm-8">
                                                    {/* <input type="text" onChange={(e) => handleChangeEntry("portal-favicon", e)}
                                                        className={showErrorPortalFavicon == true ? "form-control form-control-sm new-agent-error-input custom-form-control  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"}
                                                        id="colFormLabelSm" placeholder="" value={agent.prenom} /> */}
                                                    <div className="custom-file c-file-input">
                                                        <input type="file" onChange={(e) => handleChangeEntry("portal-favicon", e)} className="custom-form-control custom-file-input" id="customFile2" />
                                                        <label class="custom-file-label c-file-label custom-form-control" for="customFile">
                                                            {(config.portal.favicon?.name != null) ? config.portal.favicon?.name : ""}
                                                        </label>
                                                    </div>
                                                    {showErrorPortalFavicon === true && <span className="new-agent-error-span">{portalFaviconErrorMessage}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </div>
                                <div className="row my-3"></div>

                            </div>

                            <div className="widget widget-content widget-content-area mt-3 pt-3">
                                <div className="pl-3 mx-auto">
                                    <h5 className="modal-title py-2 mb-1 text-left " id="exampleModalLabel">{"Site Web"}</h5>
                                </div>
                                <hr />
                                <div className="w-90 mx-auto">
                                    <div className="d-flex">
                                        <div className="col-sm-4 col-xs-12 px-1">
                                            <div class="form-group row mb-4">
                                                <label for="libelle" class="col-sm-4 col-form-label col-form-label-sm text-dark ">Nom</label>
                                                <div class="col-sm-8">
                                                    <input type="text" onChange={(e) => handleChangeEntry("web-name", e)}
                                                        className={showErrorWebName == true ? "form-control custom-form-control form-control-sm new-agent-error-input  mx-auto" : "custom-form-control form-control form-control-sm mx-auto"}
                                                        id="colFormLabelSm" placeholder="" value={config.web.name} />
                                                    {showErrorWebName === true && <span className="new-agent-error-span">{webNameErrorMessage}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 col-xs-12 px-1">
                                            <div class="form-group row  mb-4">
                                                <label for="libelle" class="col-sm-4 col-form-label col-form-label-sm text-dark ">Image</label>
                                                <div class="col-sm-8">
                                                    {/* <input type="text" onChange={(e) => handleChangeEntry("web-image", e)}
                                                        className={showErrorWebImage == true ? "form-control form-control-sm new-agent-error-input custom-form-control  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"}
                                                        id="colFormLabelSm" placeholder="" value={agent.prenom} /> */}
                                                    <div className="custom-file c-file-input">
                                                        <input type="file" onChange={(e) => handleChangeEntry("web-image", e)} className="custom-form-control custom-file-input" id="customFile3" />
                                                        <label class="custom-file-label c-file-label custom-form-control" for="customFile">
                                                            {(config.web.image?.name != null) ? config.web.image?.name : ""}
                                                        </label>
                                                    </div>
                                                    {showErrorWebImage === true && <span className="new-agent-error-span">{webImageErrorMessage}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 col-xs-12 px-1">
                                            <div class="form-group row  mb-4">
                                                <label for="libelle" class="col-sm-4 col-form-label col-form-label-sm text-dark ">Favicon</label>
                                                <div class="col-sm-8">
                                                    {/* <input type="text" onChange={(e) => handleChangeEntry("web-favicon", e)}
                                                        className={showErrorWebFavicon == true ? "form-control form-control-sm new-agent-error-input custom-form-control  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"}
                                                        id="colFormLabelSm" placeholder="" value={agent.prenom} /> */}
                                                    <div className="custom-file c-file-input">
                                                        <input type="file" onChange={(e) => handleChangeEntry("web-favicon", e)} className="custom-form-control custom-file-input" id="customFile4" />
                                                        <label class="custom-file-label c-file-label custom-form-control" for="customFile">
                                                            {(config.web.favicon?.name != null) ? config.web.favicon?.name : ""}
                                                        </label>
                                                    </div>
                                                    {showErrorWebFavicon === true && <span className="new-agent-error-span">{webFaviconErrorMessage}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </div>
                                <div className="row my-3"></div>
                            </div>

                            <div className="widget widget-content widget-content-area mt-3 pt-3">
                                <div className="pl-3 mx-auto">
                                    <h5 className="modal-title py-2 mb-1 text-left " id="exampleModalLabel">{"Général"}</h5>
                                </div>
                                <hr />
                                <div className="w-90 mx-auto">
                                    <h6 className="text-center text-dark" style={{ textDecoration: "underline" }}><b>Couleurs</b></h6>
                                    <div className="d-flex">
                                        <div className="col-sm-4 col-xs-12 px-1">
                                            <div class="form-group row mb-4">
                                                <label for="libelle" class="col-sm-4 col-form-label col-form-label-sm text-dark">Primaire</label>
                                                <div class="col-sm-8">
                                                    <input type="color" onChange={(e) => handleChangeEntry("color-primary", e)}
                                                        className={showErrorColorPrimary == true ? "form-control custom-form-control form-control-sm new-agent-error-input  mx-auto" : "custom-form-control form-control form-control-sm mx-auto"}
                                                        id="colFormLabelSm" placeholder="" value={config.general.color.primary} />
                                                    {showErrorColorPrimary === true && <span className="new-agent-error-span">{colorPrimaryErrorMessage}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 col-xs-12 px-1">
                                            <div class="form-group row  mb-4">
                                                <label for="libelle" class="col-sm-4 col-form-label col-form-label-sm text-dark">Secondaire</label>
                                                <div class="col-sm-8">
                                                    <input type="color" onChange={(e) => handleChangeEntry("color-secondary", e)}
                                                        className={showErrorColorSecondary == true ? "form-control form-control-sm new-agent-error-input custom-form-control  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"}
                                                        id="colFormLabelSm" placeholder="" value={config.general.color.secondary} />
                                                    {showErrorColorSecondary === true && <span className="new-agent-error-span">{colorSecondaryErrorMessage}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 col-xs-12 px-1">
                                            <div class="form-group row  mb-4">
                                                <label for="libelle" class="col-sm-4 col-form-label col-form-label-sm text-dark ">Tertiaire</label>
                                                <div class="col-sm-8">
                                                    <input type="color" onChange={(e) => handleChangeEntry("color-tertiary", e)}
                                                        className={showErrorColorTertiary == true ? "form-control form-control-sm new-agent-error-input custom-form-control  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"}
                                                        id="colFormLabelSm" placeholder="" value={config.general.color.tertiary} />
                                                    {showErrorColorTertiary === true && <span className="new-agent-error-span">{colorTertiaryErrorMessage}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </div>
                                <div className="row my-3"></div>

                            </div>
                            <div className="new-agent-custom-modal-footer pb-3">
                                {processOngoing == false ? <Fragment>
                                    <button type="button"
                                        title={"Modifier"}
                                        className="btn btn-primary ml-3" onClick={() => handleUpdateConfig()}>{"Modifier"}</button>
                                    {/* {operationType == "new" &&
                                        <button type="button"
                                            title={"Ajouter et retourner à la liste"}
                                            className="btn btn-primary ml-3"
                                            onClick={() => console.log("retourner")}>
                                            Ajouter et Retourner</button>
                                    } */}
                                </Fragment> : <ProcessSpinner />}
                                {/* <button className="btn ml-3" data-dismiss="modal" onClick={handleBack}><i className="flaticon-cancel-12"></i> Retour</button> */}
                            </div>

                        </div> : <div style={{ marginTop: "25%" }}>
                            <Loader />
                        </div>}

                </div>
            </div>
        </div>



    )
}


export default Parametrage